// extracted by mini-css-extract-plugin
export default {"loadingContainer":"PatientPage_loadingContainer__9GXH5"};